import { Button } from "client/Components";
import { IValueInputAttachable } from "client/Forms/attachable";
import {
	forwardRef,
	ReactElement,
	Ref,
	RefObject,
	useImperativeHandle,
	useRef
} from "react";
import { RecipientsAutocomplete, RecipientsAutocompleteHandle } from "./RecipientsAutocomplete";
import styles from "./RecipientSelector.module.less";

export type RecipientSelectorHandle = {
	focusInput(): void;
};

export type RecipientSelectorProps = {
	label: string;
	attachable: IValueInputAttachable<string>;
	onOpenRecipientDialog(): void;
};

export const RecipientSelector = forwardRef(
	(props: RecipientSelectorProps, ref: Ref<RecipientSelectorHandle>): ReactElement => {
		const {
			attachable,
			label,
			onOpenRecipientDialog
		} = props;

		const autoCompleteRef: RefObject<RecipientsAutocompleteHandle | null> = useRef<RecipientsAutocompleteHandle>(null);

		useImperativeHandle(
			ref,
			(): RecipientSelectorHandle => ({
				focusInput(): void {
					autoCompleteRef.current
						?.focusInput();
				},
			}),
			[]
		);

		return (
			<div className={styles.root}>
				<div className={styles.buttonContainer}>
					<Button
						kind="secondary"
						text={label}
						onClick={onOpenRecipientDialog}
						width="fill"
						trackingId={`${attachable.reducer.path}_open-dialog-button`}
					/>
				</div>
				<RecipientsAutocomplete
					{...attachable.attachToTextInput()}
					ref={autoCompleteRef}
					menuTitle={label}
				/>
			</div>
		);
	}
);
RecipientSelector.displayName = "RecipientSelector";